<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
  created() {
    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(Object.assign(
              {},
              this.$store.state,
              JSON.parse(sessionStorage.getItem("store"))
          )
      )
    }
    //在页面刷新时将vuex里的信息保存到sessionStorage里
    //在ios中，beforeunload被弃用改只用pagehid
    window.addEventListener("pagehide", () => {
      sessionStorage.setItem("store", JSON.stringify(this.$store.state))
    })
  }
};
</script>
<style scoped>

</style>
